import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetTutorQuery = ({
  id,
  payload = {},
}: {
  id: string;
  payload?: Record<string, any>;
}) => {
  const token = localStorage.getItem("W2ST_STUDENT_TOKEN");

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );

  return useQuery({
    queryKey: ["getTutor", id, cleanedPayload],
    queryFn: async () => {
      if (!token) throw new Error("Authorization token is missing");

      const response = await axiosInstance.get(`users/tutors/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { ...cleanedPayload },
      });

      return response.data;
    },
    onSuccess: (data) => {
      console.log("Success Getting Tutors ==>", data);
    },
    onError: (error) => {
      console.error("Failed Getting Tutors ==>", error);
    },
    enabled: !!token,
  });
};
